var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50008 8.89096H25.1501M1.50008 16.281H25.1501M8.89108 1.49996V23.672M6.23008 23.672H20.4201C21.4698 23.79 22.5327 23.6801 23.5361 23.35C24.0924 23.0665 24.5447 22.6143 24.8281 22.058C25.1583 21.0545 25.2681 19.9917 25.1501 18.942V6.22996C25.2681 5.18022 25.1583 4.11738 24.8281 3.11396C24.5447 2.55765 24.0924 2.10537 23.5361 1.82196C22.5327 1.49177 21.4698 1.38194 20.4201 1.49996H6.23008C5.18034 1.38194 4.1175 1.49177 3.11408 1.82196C2.55778 2.10537 2.1055 2.55765 1.82208 3.11396C1.49189 4.11738 1.38206 5.18022 1.50008 6.22996V18.942C1.38206 19.9917 1.49189 21.0545 1.82208 22.058C2.1055 22.6143 2.55778 23.0665 3.11408 23.35C4.1175 23.6801 5.18034 23.79 6.23008 23.672Z",
    stroke: "#FFB666",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/EmptyImage.99bc30838c91ab7fc9788b744e41a7df.svg";
export { ForwardRef as ReactComponent };